export default "__VITE_ASSET__tc167b07__"